<template>
  <div class="bindDeviceWrap" v-loading="loading">
    <text-tip v-if="tipShow" class="textTip" @closeTip="closeTip">
      <div>1.自定义设备标识: 是用户自定义的用于标识一台设备的字符串。为方便您管理和记忆设备，您可以使用设备型号、IP地址、设备所处地理位置等信息的组合作为自定义设备标识。</div>
      <div>2. 您可通过点击“产品代码”列表项内容，查看对应产品的“License使用指南”，以便您获取更多帮助信息。</div>
    </text-tip>
    <div class="operateClass">
      <div>
        <el-button type="primary" @click="add">新增</el-button>
        <el-button type="primary" @click="batchAddDevice">批量录入设备</el-button>
        <el-button type="primary" plain @click="remove">移除</el-button>
      </div>
      <div>
        <el-button type="primary" plain @click="seeHelp">查看帮助</el-button>
      </div>
    </div>
    <table-form
      ref="tableForm"
      class="tableForm"
      :cols="cols"
      :colVails="colVails"
      :formTable="formTable"
      :row-key="getRowKey"
      :config="config"
      @selection-change="handleSelectionChange"
    >
      <template v-slot:deviceName="slotData">
        <div class="deviceName" @click="customDeivceClick(slotData.row)">
          <el-input v-model="slotData.row.deviceName" :disabled="!slotData.row.id">
            <div slot="suffix" class="inputImgWrap">
              <img v-if="!slotData.row.id" src="../../../assets/img/edit_disable.svg" class="inputImgClass disableClass" alt="" />
              <el-tooltip v-else class="item" effect="dark" offset="10" content="录入设备信息" placement="top-start">
                <img src="../../../assets/img/edit.svg" @click="editCode" class="inputImgClass" alt="" />
              </el-tooltip>
            </div>
          </el-input>
          <div class="customDeivceErrorClass" v-if="customDeivceError[slotData.row.id]">{{ customDeivceError[slotData.row.id] }}</div>
        </div>
      </template>
      <template v-slot:licenseKey="slotData">
        <el-form-item v-if="!slotData.row.id" label="" class="licenseKey" :prop="`data.${slotData.index}.licenseKey`" :rules="colVails['licenseKey']">
          <div class="authCodeItem">
            <el-input v-model="slotData.row.licenseKey">
              <div slot="suffix" class="inputImgWrap">
                <img
                  src="../../../assets/img/delete.svg"
                  @click="deleteCodeValue(slotData.row)"
                  v-show="slotData.row.licenseKey"
                  class="inputImgClass"
                  alt=""
                />
                <el-tooltip class="item" effect="dark" offset="10" content="上传授权二维码" placement="top-start">
                  <img src="../../../assets/img/code.svg" @click="clickCode(slotData.row)" class="inputImgClass deleteImg" alt="" />
                </el-tooltip>
              </div>
            </el-input>
            <el-tooltip class="item" effect="dark" offset="10" content="追加" placement="top-start">
              <img src="../../../assets/img/save.svg" @click="saveCode(slotData.formRef, slotData)" class="inputImgClass saveImg" alt="" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" offset="10" content="移除" placement="top-start">
              <img src="../../../assets/img/delete.svg" @click="deleteCode(slotData)" class="inputImgClass deleteImg" alt="" />
            </el-tooltip>
          </div>
        </el-form-item>
        <div v-else>{{ slotData.row.licenseKey }}</div>
      </template>
      <template v-slot:productCode="slotData">
        <div @click="productCodeClick(slotData.row.instructionsList)" class="productCode">{{ slotData.row.productCode || '' }}</div>
      </template>
      <template v-slot:certificateTime="slotData">
        <div>{{ slotData.row.certificateTime || '--' }}</div>
      </template>
    </table-form>

    <!-- 二维码弹窗 -->
    <dialog-code v-if="dialogCodeFlag" :visible.sync="dialogCodeFlag" @cancelCodeDialog="cancelCodeDialog"></dialog-code>

    <!-- 信息录入弹窗 -->
    <dialog-info-entry
      v-if="dialogInfoFlag"
      :visible.sync="dialogInfoFlag"
      :licenseKeys="licenseKeyList"
      :checkList="currentCheck"
      :isBatch="isBatch"
      :itemIds="rowIds"
      :deviceName="deviceName"
      @cancelDialog="cancelDialog"
      @cancelLoading="cancelLoading"
      @callBackData="callBackData"
    ></dialog-info-entry>

    <dialog-common
      v-if="dialogCommon"
      :visible.sync="dialogCommon"
      title="提示"
      @handleConfirm="handleConfirm"
      @handleClose="handleClose">
        <img width="16" height="16" style="margin-right: 8px;" src="../../../assets/img/warn.svg"  alt="">
        <span>您确认要移除选中项吗？</span>
    </dialog-common>
  </div>
</template>
<script>
import tableForm from '~/components/table-form.vue';
import textTip from '~/components/text-tip.vue';
import DialogCode from './Dialog/DialogCode.vue';
import DialogInfoEntry from './DialogInfoEntry/index.vue';
import DialogCommon from "./Dialog/DialogCommon.vue";
import { mapState } from 'vuex';
import requestActiveLicense from '~/request/requestActiveLicense';
import { generateUUID } from '~/util/commonUtil';
export default {
  components: {
    tableForm,
    textTip,
    DialogCode,
    DialogInfoEntry,
    DialogCommon
  },
  data() {
    return {
      loading: false,
      dialogCommon: false,
      sended: false,
      customDeivceError: {},
      customDeivceInfo: [],
      currentCheck: [], // 当前整个表格选中
      isShow: false,
      currentRow: {}, // 单个行或者当前页选中的
      dialogCodeFlag: false, // 二维码弹窗
      dialogInfoFlag: false, // 信息录入弹窗
      tipShow: true,
      colVails: {
        deviceName: [{ required: true, message: '请填写设备信息', trigger: ['change'] }],
        licenseKey: [
          { required: true, message: '授权码不能为空', trigger: ['blur'] },
          { validator: this.licenseKeyValidate, trigger: 'blur' },
        ],
      },
      cols: [
        { label: '自定义设备标识', prop: 'deviceName', minWidth: '230', slotName: 'deviceName', 'show-overflow-tooltip': true, sortable: true },
        { label: '授权码', prop: 'licenseKey', minWidth: '360', slotName: 'licenseKey', 'show-overflow-tooltip': true, sortable: true },
        { label: '软件条码', prop: 'barCode', minWidth: '200', 'show-overflow-tooltip': true, sortable: true },
        { label: '产品代码', prop: 'productCode', minWidth: '110', slotName: 'productCode', 'show-overflow-tooltip': true, sortable: true },
        { label: '产品描述', prop: 'productDesc', minWidth: '130', 'show-overflow-tooltip': true, sortable: true },
        { label: '授权码状态', prop: 'keyState', minWidth: '110', 'show-overflow-tooltip': true, sortable: true },
        { label: '授权码类型', prop: 'keyType', minWidth: '110', 'show-overflow-tooltip': true, sortable: true },
        { label: '剩余有效时限（天）', prop: 'certificateTime', minWidth: '160', slotName: 'certificateTime', 'show-overflow-tooltip': true, sortable: true },
      ],
      formTable: {
        data: [],
      },
      config: {
        selection: {
          'reserve-selection': true,
        },
      },
      licenseKeyList: null,
      rowIds: null,
      isBatch: false, // 是否批量 false为不批量，true为批量
      deviceName: '', // 设备名称
    };
  },
  activated() {
    this.formTable.data = this.bindTableData.slice();
    this.checkTableRow(this.checkTableData);
    this.$forceUpdate();
  },
  deactivated() {
    // 将选中行中的无数据的过滤掉
    let currentCheck = this.$refs.tableForm.currentSelect();
    this.$store.commit(
      'setCheckTableData',
      currentCheck.filter(item => item.id)
    );
  },
  computed: {
    ...mapState(['processId', 'tableData', 'checkTableData', 'bindTableData', 'cacheKey']),
  },
  methods: {
    productCodeClick(list){
      if(Array.isArray(list) && list.length){
        const url = (list[0] || {}).url;
        if(!url){
          this.$notify({
            title: '提示',
            message: '无匹配的License使用指南',
            type: 'warning',
          });
          return;
        }
        window.open(url);
      }
    },
    cancelLoading(){
      this.loading = false;
    },
    getRowKey(row) {
      return row.id || row.rowId;
    },
    // 通过后端数据确定并提示信息
    showTip(tipData, callback){
      if(!tipData){
        // 接口返回 null 为验证通过
        callback(false);
        return;
      }
      this.customDeivceInfo = [];
      // 表格内全量数据
      const formTableSelf = this.$refs.tableForm.getFormTableSelf();
      const currentCheck = this.$refs.tableForm.currentSelect();
      tipData.forEach(tip=> {
        if((!tip.result) && tip.licenseKey){
          // 未通过 && 有授权码
          currentCheck.forEach((check) => {
            if(tip.licenseKey === check.licenseKey){
              this.$set(this.customDeivceError, check.id, tip.message || '请填写设备信息');
              const position = formTableSelf.indexOf(check);
              if(position != -1){
                this.customDeivceInfo.push(`<div>第${position + 1}行 ${tip.message || '请填写设备信息'}</div>`)
              }
            }
          })
        }
      })
      if(this.customDeivceInfo.length){
        this.$alert(`<div>${this.customDeivceInfo.join('')}</div>`, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          showClose: true,
          customClass: 'alertClass bindDeviceAlert'
        });
        callback(true);
        return;
      }
      callback(false);
    },
    getVail() {
      return new Promise((resovle, reject) => {
        const currentCheck = this.$refs.tableForm.currentSelect();
        if(!currentCheck.length){
          this.$notify({
            title: '提示',
            message: '请至少选择一个有效的授权码！',
            type: 'warning',
          });
          return reject();
        }
        // this.customDeivceInfo = [];
        // const formTableSelf = this.$refs.tableForm.getFormTableSelf();
        // // 遍历当前选中数据判断是否展示对应错误
        // currentCheck.forEach((check) => {
        //   if(check.licenseKey){
        //     this.$set(this.customDeivceError, check.id, '');
        //     check.customDeivceError = false;
        //     if(!check.deviceName){
        //       // 区分是否绑定设备
        //       this.$set(this.customDeivceError, check.id, '请填写设备信息');
        //       const position = formTableSelf.indexOf(check);
        //       if(position != -1){
        //         this.customDeivceInfo.push(`<div>第${position + 1}行 请填写设备信息</div>`)
        //       }
        //     }
        //   }
        // })
        // if(this.customDeivceInfo.length){
        //   this.$alert(`<div>${this.customDeivceInfo.join('')}</div>`, '提示', {
        //     dangerouslyUseHTMLString: true,
        //     confirmButtonText: '确定',
        //     showClose: false
        //   });
        //   return reject();
        // }
        return resovle();
      });
    },
    // 选中行
    checkTableRow(rows) {
      Promise.resolve().then(() => {
        this.$refs.tableForm.clearSelection();
        rows.forEach(row => {
          this.$refs.tableForm.toggleRowSelection(row, true);
        });
      });
    },
    handleSelectionChange(selection) {
      this.currentCheck = selection;
      this.$store.commit('setCheckTableData', this.currentCheck);
    },
    // 点击单个录入设备
    customDeivceClick(row) {
      if (!row.id) {
        return;
      }
      this.isBatch = false;
      this.currentRow = row;
      this.rowIds = [row.id];
      this.deviceName = row.deviceName;
      this.infoEntry(row.licenseKey);
    },
    // 点击批量录入设备
    batchAddDevice() {
      this.isBatch = true;
      // 当前页勾选得数据
      this.currentRow = this.getCurrentPageCheck();
      // 批量选择，设备信息名称默认带数组中deviceName第一个有值的值
      // this.deviceName = this.checkTableData.filter(e => e.deviceName !== '')[0];
      this.deviceName = '';
      this.infoEntry();
    },
    licenseKeyValidate(rule, value, callback) {
      this.sended = true;
      let existBind = this.bindTableData.some(item => item.licenseKey === value);
      if(existBind){
        callback('该授权码已添加');
        return;
      }
      // 当前表格展示的位置
      const index = rule.field.split('.')[1];
      let param = {
        processId: this.processId,
        licenseKeyList: [value],
        'cacheKey': this.cacheKey,
        step: '2'
      };
      requestActiveLicense
        .saveAuthorizeInfo(param)
        .then(res => {
          this.sended = false;
          if (res.code == '0') {
            // 如果是已存在的，先找在再加
            // 先改选中（乱序），再其他
            const addTarget = res.res[0];
            if(addTarget.isExist === '1'){
              // 全量数据中已经存在，先删除
              const position = this.tableData.findIndex(item => item.licenseKey == addTarget.licenseKey);
              this.$store.commit('spliceIndexTableData', position);
            }
            let resOject = {};
            // 当前表格展示数据
            const formTableCurrent = this.$refs.tableForm.getFormTableCurrent();
            // 选中数据更新
            this.checkTableData.forEach(item => {
              if (item === formTableCurrent[index]) {
                resOject = Object.assign(item, addTarget);
              }
            });
            // 未选中的空行
            if(!Object.keys(resOject).length){
              // 直接 merge，然后更新选中数据
              resOject = Object.assign(formTableCurrent[index], addTarget);
              this.$store.commit('setCheckTableData', [resOject].concat(this.checkTableData));
            }
            this.$set(formTableCurrent, index, resOject);
            // 全量、以及第二页数据更新
            const resTableData = [resOject].concat(this.tableData);
            const resBindTableData = [resOject].concat(this.bindTableData);
            this.$store.commit('setTableData', resTableData);
            this.$store.commit('setBindTableData', resBindTableData);
            this.checkTableRow(this.checkTableData);
            callback();
          } else {
            callback(res.msg || '操作失败');
          }
        })
        .catch(error => {
          this.sended = false;
          callback('操作失败');
        });
    },
    // 设备信息弹窗关闭
    cancelDialog(codeValue) {
      this.dialogInfoFlag = false;
    },
    // 设备信息弹窗点开
    infoEntry(val) {
      if (this.isBatch) {
        // 选中的可能是没有授权码的行(先过滤)
        this.licenseKeyList = this.currentRow.filter(e => e.licenseKey).map(e => e.licenseKey);
        if (this.licenseKeyList.length < 1) {
          this.$notify({
            title: '提示',
            message: '请勾选需要处理的有效数据',
            type: 'warning',
          });
          return;
        }
      } else {
        this.licenseKeyList = val;
      }
      this.loading = true;
      this.dialogInfoFlag = true;
    },
    // 设备信息回调数据
    callBackData(val, licenseList, ids) {
      if(Array.isArray(this.currentRow)){
        this.currentRow.forEach(item =>{
          if(item.id){
            this.$set(item, 'deviceName', val);
          }
        })
      }else{
        this.$set(this.currentRow, 'deviceName', val);
      }
      // 历史激活文件处理
      if(Array.isArray(licenseList) && licenseList.length){
        let resTableData = this.tableData.slice();
        let resBindTableData = this.bindTableData.slice();
        let resCheckTableData = this.checkTableData.slice();
        let formTableData = this.formTable.data.slice();
        let isExist = false;
        // 防止重复数据添加
        licenseList.forEach(license =>{
          isExist = false;
          isExist = resTableData.some(item =>{
            return item.licenseKey === license.licenseKey;
          })
          if(!isExist){
            resTableData = [license].concat(resTableData);
            resBindTableData = [license].concat(resBindTableData);
            resCheckTableData = [license].concat(resCheckTableData);
            formTableData = [license].concat(formTableData);
          }
        })
        this.$store.commit('setTableData', resTableData);
        this.$store.commit('setBindTableData', resBindTableData);
        this.$store.commit('setCheckTableData', resCheckTableData);
        // this.formTable.data 中包含很多空行，与 tableData、bindTableData、checkTableData 数据存在不同
        this.formTable.data = formTableData;
        this.checkTableRow(resCheckTableData);
      }
    },
    seeHelp() {
      window.open(`${location.origin}/document/license_activation_step2.html`);
    },
    clickCode(row) {
      this.currentRow = row;
      this.dialogCodeFlag = true;
    },
    cancelCodeDialog(codeValue) {
      if (codeValue) {
        this.currentRow.licenseKey = codeValue;
      }
      this.dialogCodeFlag = false;
    },
    deleteCodeValue(row) {
      row.licenseKey = '';
    },
    saveCode(formRef, slotData) {
      if(this.sended) { return };
      formRef.validateField(`data.${slotData.index}.licenseKey`, err => {});
    },
    deleteCode({ row, index }) {
      if (row.id) {
        // 存在数据库中的数据
        this.removeFuc(row.id, () => {
          this.formTable.data.splice(index, 1);
          this.$store.commit('spliceTableData', row);
          this.$store.commit('spliceBindTableData', row);
          this.$store.commit('spliceCheckTableData', row);
          this.checkTableRow(this.checkTableData);
        });
      } else {
        this.formTable.data.splice(index, 1);
        this.$store.commit('spliceCheckTableData', row);
        this.checkTableRow(this.checkTableData);
      }
    },
    editCode() {},
    closeTip() {
      this.tipShow = false;
    },
    add() {
      let row = {
        rowId: generateUUID(),
        deviceName: '',
        licenseKey: '',
        barCode: '',
        productCode: '',
        productDesc: '',
        keyState: '',
        keyType: '',
        certificateTime: '',
      };
      // 空行只会存在 store 中的 checkTableData，不会存在 store 中的其他变量中
      this.formTable.data.unshift(row);
      this.checkTableRow([row].concat(this.currentCheck));
    },
    spliceTarget(array, obj) {
      const index = array.indexOf(obj);
      if (index === -1) {
        return [];
      }
      return array.splice(index, 1);
    },
    handleConfirm(){
      // const currentCheck = this.currentCheck.slice();
      const currentCheck = this.getCurrentPageCheck();
      const ids = currentCheck.filter(check => check.id);
      if (ids.length) {
        // 存在数据库中的数据以及占位数据两种
        this.removeFuc(ids, () => {
          currentCheck.forEach(check => {
            this.spliceTarget(this.formTable.data, check);
            this.$store.commit('spliceTableData', check);
            this.$store.commit('spliceBindTableData', check);
            this.$store.commit('spliceCheckTableData', check);
          });
          this.checkTableRow(this.checkTableData);
        });
      } else {
        currentCheck.forEach(check => {
          this.formTable.data.splice(this.formTable.data.indexOf(check), 1);
          this.$store.commit('spliceCheckTableData', check);
        });
        this.checkTableRow(this.checkTableData);
      }
    },
    handleClose(){
      this.dialogCommon = false;
    },
    // 获取当前页选中数据
    getCurrentPageCheck(){
      // 当前页数据
      const formTableCurrent = this.$refs.tableForm.getFormTableCurrent();
      // 所有选中数据
      const currentCheck = this.currentCheck.slice();
      let result = [];
      formTableCurrent.forEach(item => {
        let flag = currentCheck.some(check =>{
          return check === item
        })
        flag && result.push(item);
      })
      return result
    },
    remove() {
      // const currentCheck = this.currentCheck.slice();
      const currentCheck = this.getCurrentPageCheck();
      if (!currentCheck.length) {
        this.$notify({
          title: '提示',
          message: '请至少选择一个有效的授权码！',
          type: 'warning',
        });
        return;
      }
      this.dialogCommon = true;
    },
    removeFuc(value, callback) {
      let ids = [value];
      if (Array.isArray(value)) {
        ids = value.map(check => check.id);
      }
      const param = {
        ids,
        processId: this.processId,
        'licenseKeyList': value.map(item => item.licenseKey),
        'cacheKey': this.cacheKey,
        'step': '2'
      };
      requestActiveLicense
        .removeAuthorizeInfos(param)
        .then(res => {
          if (res.code == '0') {
            callback();
            this.$notify({
              title: '成功',
              message: res.msg || '操作成功',
              type: 'success',
            });
          }
        })
        .catch(error => {
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.bindDeviceWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .textTip {
    margin-bottom: 15px;
  }
  .operateClass {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  // .el-form-item.licenseKey.is-error {
  //   padding-bottom: 28px;
  // }
  .licenseKey {
    .authCodeItem {
      display: flex;
      align-items: center;
      .inputImgWrap {
        padding-top: 3px;
      }
      .inputImgClass {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
      .saveImg {
        margin-left: 12px;
      }
      .deleteImg {
        margin-left: 10px;
      }
      .el-input--suffix .el-input__inner {
        padding-right: 44px;
      }
    }
    /deep/ .el-form-item__error{
      position: relative;
    }
  }
  .deviceName {
    .inputImgWrap {
      padding-top: 6px;
      .inputImgClass {
        width: 14px;
        height: 15px;
        cursor: pointer;
      }
      .disableClass {
        cursor: not-allowed;
      }
    }
    .customDeivceErrorClass {
      width: 100%;
      white-space: normal;
      font-size: 12px;
      color: #f56c6c;
      line-height: 1;
      margin-top: 4px;
    }
  }
  .productCode{
    cursor: pointer;
    color: @currentColor;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
// .authCodeInput /deep/ .el-form-item.is-error{
//   padding-bottom: 30px;
// }
// .tableForm /deep/ .el-input--small .el-input__inner{
//       height: 25.6px;
//       line-height: 25.6px;
//     }
</style>
